export const ypoConstants = {
    general: {
        READ_MORE: 'Read More',
        EDIT_MESSAGE: 'Edit Message',
        Add_About_MESSAGE: 'Add About Message',
        Add_CHAIR_MESSAGE: 'Add Chair Message',
    },
    label: {
        MESSAGE_FROM_CHAIRMAN: 'MSG. FROM CHAIRMAN',
        CHAPTER_CHAIR: 'Chapter Chair',
    },
    value: {
        chapterChairTextMaxLength: 200,
    },
};
export const ypoMenuConstants = {
    homeMenu: 'homeMenu',
    quickLinksMenu: 'quickLinksMenu',
    notificationMenu: 'notificationMenu',
};

export const ypoToggleButtonConstant = {
    defaultToggleLabel: "On",
    postToggleLabel: "Off",
    toggleDefaultColor: "blue",
    postToggleColor: "gray",
};
